import { render } from "./mpesaPayments.vue?vue&type=template&id=5cf26d39&scoped=true"
import script from "./mpesaPayments.vue?vue&type=script&lang=js"
export * from "./mpesaPayments.vue?vue&type=script&lang=js"

import "./mpesaPayments.vue?vue&type=style&index=0&id=5cf26d39&scoped=true&lang=css"

import exportComponent from "/var/www/html/heritage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf26d39"]])

export default __exports__